<template>
  <div class="Section">
    <h3 class="Section__header">{{ $prismic.richTextAsPlain(getPrimary) }}</h3>
    <prismic-rich-text
      v-for="(para, index) in getItems"
      :key="index"
      :field="para.section_text"
      class="Section__paragraph"
    />
  </div>
</template>

<script>
  export default {
    name : 'Section',
    props : {
      content : {
        type : Object,
        default : null
      }
    },
    computed : {
      getPrimary() {
        return this.content.primary['section_heading'];
      },
      getItems() {
        return this.content.items;
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/scss/shared.scss';
  .Section {
    &__header {
      font-size: 2rem;
    }
    &__paragraph {
      font-size: 1.6rem;
    }
  }
</style>